export default "__VITE_ASSET__Bzr9t_xi__"